/// <reference path="../../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";

import {resourceStrings} from "../../../../../Intercom.ReactUI/Views/index";
import {BotService} from "../../../Generated/RestClient";

export interface CookieInformProps extends React.Props<CookieInform> {
}

export class CookieInform extends React.Component<CookieInformProps, {}> {
    constructor(props) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <div className="status-bar info cookie-inform">
                This site uses cookies for analytics, personalized content and ads. By continuing to browse this site, you agree to this use.&nbsp;
                <a href="//go.microsoft.com/fwlink/?linkid=845480" target="_blank">Learn more</a>.
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/status/CookieInform.tsx